export const ADD_COMMENT = "ADD_COMMENT";
export const CAMPSITES_LOADING = "CAMPSITES_LOADING";
export const CAMPSITES_FAILED = "CAMPSITES_FAILED";
export const ADD_CAMPSITES = "ADD_CAMPSITES";
export const ADD_COMMENTS = "ADD_COMMENTS";
export const COMMENTS_FAILED = "COMMENTS_FAILED";
export const PROMOTIONS_LOADING = "PROMOTIONS_LOADING";
export const ADD_PROMOTIONS = "ADD_PROMOTIONS";
export const PROMOTIONS_FAILED = "PROMOTIONS_FAILED";

export const PARTNERS_LOADING = "PARTNERS_LOADING";
export const ADD_PARTNERS = "ADD_PARTNERS";
export const PARTNERS_FAILED = "PARTNERS_FAILED";
